import React from "react";
import {
  Box,
  Card,
  CardBody,
  CardHeader,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Stack,
  Flex,
  Text,
  Tooltip,
  HStack,
  Button,
  Icon,
  ModalFooter
} from "@chakra-ui/react";
import ViewMetricCardContainer from "../../containers/configuration/ViewMetricCardContainer";
import { IoMdAdd } from "react-icons/io";
import EditMetricDefinitionContainer from "../../containers/configuration/EditMetricDefinitionContainer";
import AddDescriptionContainer from "../../containers/configuration/snowflake/AddDescriptionContainer";
import { IoMdOptions } from "react-icons/io";
import { AiOutlineDelete } from "react-icons/ai";
import { MdSync } from "react-icons/md";
import { Header, ModelInfo } from "build-ts/metadata";
import { syncDataModel } from "../../services/DataModelService";
import showToast from "../../hooks/useCustomToast";

interface ViewMetricByModelProps {
  listModel: Header[];
  metricList: Header[];
  handleCreateMetric: (id: string) => void;
  modelInfo: ModelInfo | null;
  isOpen: boolean;
  metricFlag: boolean;
  closeMetric: () => void;
  handleUpdateModel: (id: string) => void;
  modelFlag: boolean;
  deleteModal: {
    isOpen: boolean;
    onOpen: () => void;
    onClose: () => void;
  };
  confirmDelete: () => void;
  setDeleteModelId: React.Dispatch<React.SetStateAction<string | null>>;
  dependentMetricHeaders: Header[];
  setDependentMetricHeaders: React.Dispatch<React.SetStateAction<Header[]>>;
  modelsWithMissingKG: Set<string>;
  onBack: () => void;
  onNavigateToGraph?: () => void;
}

const ViewMetricByModel: React.FC<ViewMetricByModelProps> = ({ 
  listModel, 
  metricList,
  handleCreateMetric, 
  modelInfo, 
  isOpen, 
  metricFlag, 
  closeMetric, 
  handleUpdateModel, 
  modelFlag,
  deleteModal,
  confirmDelete,
  setDeleteModelId,
  dependentMetricHeaders,
  setDependentMetricHeaders,
  modelsWithMissingKG,
  onBack,
  onNavigateToGraph
}) => {
  // Create a wrapper function that matches the expected navigateTo signature
  const handleNavigateToGraph = (success: boolean) => {
    if (success && onNavigateToGraph) {
      onNavigateToGraph();
    }
  };

  // Handle resync functionality
  const handleResync = async (modelId: string) => {
    try {
      // Call the sync API
      const result = await syncDataModel(modelId);
      if (result) {
        showToast("Model synced successfully", "", "success");
        // Optionally refresh the model list or trigger a re-fetch
      }
    } catch (error) {
      console.error("Error syncing model:", error);
      showToast("Error syncing model", "", "error");
    }
  };

  // Render the ViewMetric component
  return (
    <Box overflowY="auto" height="94vh">
      {!metricFlag && !modelFlag && (
      <Stack>
        {listModel &&
          listModel.map((model, index) => (
            <Card
              key={index}
              m={1}
              ml={3}
              p={3}
              boxShadow="md"
              borderColor={modelsWithMissingKG.has(model.id!) ? "red.500" : undefined}
              borderWidth={modelsWithMissingKG.has(model.id!) ? "2px" : undefined}
              borderRadius="1px"
              bg="white"
            >
              <CardHeader textAlign="left" m={0} p={1}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Text fontSize="lg" fontWeight="bold" color="fg.muted" mb={0}>{model.name?.replace(/_/g, " ")}</Text>
                  <HStack spacing="2">
                  <Tooltip label="New Metric" color="black" bg="gray.50">
                    <Button
                      variant="secondary"
                      justifyContent="start"
                      iconSpacing="2"
                      leftIcon={<Icon as={IoMdAdd} boxSize="1rem" />}
                      onClick={() => handleCreateMetric(model.id!)}
                      aria-label="Add"
                      size="sm"
                      color="fg.default"
                      _hover={{bg: "gray.50"}}
                    >
                    <Text mb={0} fontWeight={600}>
                      Metric
                    </Text>  
                    </Button>
                  </Tooltip>
                  <Tooltip label="Update Model" color="black" bg="gray.50">
                    <IconButton
                      icon={<IoMdOptions />}
                      onClick={() => handleUpdateModel(model.id!)}
                      aria-label="Add"
                      size="sm"
                      color="fg.default"
                      _hover={{bg: "gray.50"}}
                    />
                  </Tooltip>
                  <Tooltip label="Resync Model" color="black" bg="gray.50">
                    <IconButton
                      icon={<MdSync />}
                      onClick={() => handleResync(model.id!)}
                      aria-label="Resync Model"
                      size="sm"
                      color="fg.default"
                      _hover={{ bg: "gray.50" }}
                    />
                  </Tooltip>
                  <Tooltip label="Delete Model" color="black" bg="gray.50">
                  <IconButton
                    icon={<AiOutlineDelete />}
                    onClick={() => {
                      setDeleteModelId(model.id!); // Set the selected model ID
                      deleteModal.onOpen(); // Open the delete modal
                    }}
                    aria-label="Delete"
                    size="sm"
                    color="fg.default"
                    _hover={{ bg: "gray.50" }}
                  />
                  </Tooltip>
                  </HStack>
                </Box>
              </CardHeader>
              <CardBody>
                <ViewMetricCardContainer modelId={model.id!} metricList={metricList} />
              </CardBody>
            </Card>
          ))}
      </Stack>
      )}
      {metricFlag && (<Modal
      isOpen={isOpen}
      onClose={closeMetric}
      isCentered
      motionPreset="scale"
      >
      <ModalOverlay bg="blackAlpha.300" />
      <ModalContent m="5%" maxW="90vw" maxH="90vh" overflow="hidden" >
        <ModalHeader>
        <Flex
          direction="row"
          justify="space-between"
          align="center"
          width="100%"
        >
          {/* Metric Name Section */}
          <Flex
            direction="column"
            justify="center"
            flex="1"
            p={1}
          >
            <Text
              fontSize="lg"
              fontWeight="bold"
              color="black"
              mb={0}
            >
              {" "}
              Define Metric
            </Text>
          </Flex>
        </Flex>
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody overflow="auto">
        {/* <DefineMetricContainer modelInfo={modelInfo} metricInfo={handleMetricChange} onClose={onClose}/> */}
        <EditMetricDefinitionContainer createMetricFlag={true} modelInfo={modelInfo} metricHeader={null} onClose={closeMetric}/>
        </ModalBody>
      </ModalContent>
    </Modal>)}
      {modelFlag && (
        <AddDescriptionContainer modelInfo={modelInfo} navigateTo={handleNavigateToGraph} updateFlag={true} handleCreateDataModel={null} onBack={onBack}/>
      )}
      {/* Delete model modal */}
      <Modal isOpen={deleteModal.isOpen} onClose={deleteModal.onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          {dependentMetricHeaders.length > 0 ? (
            <>
              <ModalHeader fontSize="md">Cannot Delete Model</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Text mb={2}>Please delete the following dependent metrics first:</Text>
                <Stack spacing={0}>
                  {dependentMetricHeaders.map((header, idx) => (
                    <Text key={idx} ml={4} mb={0}>• {header.name}</Text>
                  ))}
                </Stack>
              </ModalBody>
              <ModalFooter>
                <Button variant="ghost" onClick={() => {
                  deleteModal.onClose();
                  setDependentMetricHeaders([]);
                }}>
                  Close
                </Button>
              </ModalFooter>
            </>
          ) : (
            <>
              <ModalHeader fontSize="md">Delete Model Confirmation</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Text>Are you sure you want to delete this model?</Text>
              </ModalBody>
              <ModalFooter>
                <Button colorScheme="purple" mr={3} onClick={confirmDelete}>
                  OK
                </Button>
                <Button
                  variant="ghost"
                  onClick={() => {
                    setDeleteModelId(null); // Reset the deleteId if deletion is canceled
                    deleteModal.onClose();
                  }}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default ViewMetricByModel;